import { FilterDocument } from '@griply/types';
import { buildTodayFilterDocument } from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const useTodayFilterDocument = (): FilterDocument => {
  const user = useUser();
  const today = useToday();

  return useMemo(
    () => buildTodayFilterDocument(today, user?.settings),
    [today, user?.settings],
  );
};
